import React from "react";
import {
  Stack,
  Text,
  useDisclosure,
  Container,
  Button,
  Box,
  Image,
  Input,
  HStack,
  Heading,
  Textarea,
  Center,
  Modal,
  Link,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  useColorMode,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import Seo from "../../utils/Seo";

import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";

import { useState } from "react";

import Testimonials from "../Testimonials";

import Work from "./work22.png";
import CrumForsterLogo from "./crum-forster-logo.png";
import DyausTechLogo from "./dyaus-tech-logo2.png";

export default function Experiences() {
  const borderColor = useColorModeValue("gray.300", "transparent");

  const linkedin = () => {
    window.open(
      "https://www.linkedin.com/in/ayush-s-673990130/",
      "_blank",
      "noreferrer,noopener"
    );
  };
  const github = () => {
    window.open("https://github.com/Ayushaff", "_blank", "noreferrer,noopener");
  };
  const email = () => {
    window.open(
      "mailto:aayushsharma11403@gmail.com?subject=[SUBJECT]Hi ayush👋🏻, This is regarding.. &body=[BODY] That we approve you as spiderMan",
      "_blank",
      "noreferrer,noopener"
    );
  };

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const sendEmail = () => {
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);
    const emailLink = `mailto:aayushsharma11403@gmail.com?subject=${encodedSubject}&body=${encodedBody}`;
    window.location.href = emailLink;
  };

  const { colorMode } = useColorMode();

  return (
    <>
      <Seo />
      <Container maxW={"4xl"} id="experiences">
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          pb={{ base: 0, md: 0 }}
        >
          <Heading
            mt={"10%"}
            mb={"-6%"}
            fontSize={"4xl"}
            color={useColorModeValue("rgb(45, 55, 72)", "white")}
          >
            {colorMode === "light" ? (
              <Text as="span" color="rgb(7, 190, 184)">
                Work
              </Text>
            ) : (
              <Text
                as="span"
                bgGradient="linear(to-br, #228be6, #15aabf)"
                bgClip="text"
              >
                Work
              </Text>
            )}{" "}
            Experience
          </Heading>

          <Flex
            mt={{ base: "-2%", sm: "2%", md: "1%", lg: "0.5%" }}
            alignItems="center"
            justifyContent="center"
          >
            <Box
              w="50%"
              h="1px"
              bg={useColorModeValue("rgb(26, 32, 44)", "rgb(233, 237, 242)")}
            />
            <Text mx="1rem" whiteSpace="nowrap">
              😃👨🏻‍💼
            </Text>
            <Box
              w="50%"
              h="px"
              bg={useColorModeValue("rgb(26, 32, 44)", "rgb(233, 237, 242)")}
            />
          </Flex>
        </Stack>

       {/* Crum and Forster Section */}
<Stack
  justifyContent={"center"}
  direction={{ base: "column", md: "row" }}
  alignItems={"center"}
  pt={"40px"}
>
  <Link href="https://www.cfins.com/" isExternal>
    <Stack direction="column" spacing={4} alignItems="center" pt={8}>
      <Image
        height={"100px"}
        width={"auto"}
        objectFit="contain"
        src={CrumForsterLogo}
        border="1px"
        borderColor={borderColor}
      />
      <Heading
        size="md"
        fontWeight="semibold"
        color={useColorModeValue("teal.500", "teal.200")}
      >
        Crum and Forster
      </Heading>
      <Text
        fontSize="md"
        color={useColorModeValue("gray.600", "gray.300")}
        mb={2}
      >
        (August 2025 - Present)
      </Text>
      <Text textAlign="left" maxW="lg">
        <ul>
          <li>
            Designing and deploying AI-powered insurance solutions using
            LangChain, LLMs (GPT-4o, Mistral), and vector databases (Pinecone,
            Weaviate) to automate claims processing and enhance underwriting
            workflows.
          </li>
          <li>
            Implemented RAG (Retrieval-Augmented Generation) systems to ground
            LLM responses in internal knowledge bases, reducing hallucinations
            and increasing compliance accuracy for regulatory use cases.
          </li>
          <li>
            Built scalable full-stack applications with Next.js (React), Node.js,
            and Python services; integrated generative AI features into
            customer-facing portals.
          </li>
          <li>
            Enabling CI/CD pipelines with GitHub Actions for rapid deployment and
            A/B testing of AI models.
          </li>
          <li>
            Optimized data architecture by MySQL for transactional records,
            improving query performance by 35% through schema redesign and
            indexing.
          </li>
        </ul>
      </Text>
    </Stack>
  </Link>
</Stack>

{/* Dyaus Tech Section */}
<Stack
  justifyContent={"center"}
  direction={{ base: "column", md: "row" }}
  alignItems={"center"}
  pt={"40px"}
>
  <Link href="https://rentprompts.ai/" isExternal>
    <Stack direction="column" spacing={4} alignItems="center" pt={8}>
      <Image
        height={"100px"}
        width={"300px"}
        objectFit="contain"
        src={DyausTechLogo}
        border="1px"
        borderColor={borderColor}
      />
      <Heading
        size="md"
        fontWeight="semibold"
        color={useColorModeValue("teal.500", "teal.200")}
      >
        Dyaus Tech
      </Heading>
      <Text
        fontSize="md"
        color={useColorModeValue("gray.600", "gray.300")}
        mb={2}
      >
        (April 2024 - July 2025)
      </Text>
      <Text textAlign="left" maxW="lg">
        <ul>
          <li>
            Built a scalable AI platform for creating chatbots and automation
            tools, collaborating with cross-functional teams to integrate
            diverse language models using Python, FastAPI, and Docker.
          </li>
          <li>
            Streamlined external API access for AI agents, improving response
            times with Redis caching for seamless user experiences.
          </li>
          <li>
            Developed plugins for real-time customer support and automated
            workflows (e.g., report generation, HR scheduling), boosting platform
            versatility.
          </li>
          <li>
            Enhanced query performance with Vastbase vector databases, enabling
            efficient handling of large-scale user requests.
          </li>
        </ul>
      </Text>
    </Stack>
  </Link>
</Stack>

        <Stack
          justifyContent={"center"}
          direction={{ base: "column", md: "row" }}
          alignItems={"center"}
          pt={"40px"}
        >
          <Link
            href="https://wakatime.com/@303a8372-abc8-4047-8f4a-be886b6c9a64/projects/egbbhrspdu"
            isExternal
          >
            <Image
              height={"200px"}
              width={"auto"}
              objectFit="contain"
              src="https://wakatime.com/static/img/blog/insights.gif"
              border="2px"
              borderColor={borderColor}
            />
          </Link>

          <Image
            height={"200px"}
            width={"auto"}
            objectFit="contain"
            src={Work}
            border="1px"
            borderColor={borderColor}
          />

          <Link
            href="https://wakatime.com/share/@303a8372-abc8-4047-8f4a-be886b6c9a64/161f8748-f4b8-40e5-998f-d5ae9b1be2df.svg"
            isExternal
          >
            <Image
              height={"200px"}
              width={"auto"}
              objectFit="contain"
              src="https://wakatime.com/share/@303a8372-abc8-4047-8f4a-be886b6c9a64/161f8748-f4b8-40e5-998f-d5ae9b1be2df.svg"
              border="1px"
              borderColor={borderColor}
            />
          </Link>
        </Stack>
<Flex
          mt={{ base: "2%", sm: "2%", md: "1%", lg: "0.5%" }}
          pt={"20px"}
          alignItems="center"
          justifyContent="center"
        >
          <Box
            w="50%"
            h="1px"
            bg={useColorModeValue("rgb(26, 32, 44)", "rgb(233, 237, 242)")}
          />
          <Text mx="1rem" whiteSpace="nowrap" fontSize="md" fontStyle="italic">
            "Striving for excellence in every line of code"
          </Text>
          <Box
            w="50%"
            h="1px"
            bg={useColorModeValue("rgb(26, 32, 44)", "rgb(233, 237, 242)")}
          />
        </Flex>
        <Container alignItems={"center"} maxW={"3xl"} pt={"40px"} pb={"20px"}>
          <Box>
            <Text textAlign={"center"} fontSize={"md"}>
              <i>
                I'm a dedicated full-stack developer with a passion for building
                scalable, innovative solutions. My proactive learning approach and
                commitment to excellence enable me to deliver impactful results
                across diverse tech stacks.
              </i>
            </Text>
            <Text textAlign={"center"}>
              <i>
                I’m always open to new opportunities to contribute and grow.
              </i>{" "}
              Feel free to reach out at{" "}
              <u>
                <a href="mailto:aayushsharma11403@gmail.com">
                  aayushsharma11403@gmail.com
                </a>
              </u>
              .
            </Text>
          </Box>

          <Center>
            <HStack pt={4} spacing={4}>
              <FaLinkedin onClick={linkedin} size={28} />
              <FaGithub onClick={github} size={28} />
              <FaEnvelope onClick={onOpen} size={28} />

              <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader>Compose Email</ModalHeader>

                  <Text
                    color={`teal.400`}
                    fontWeight={600}
                    fontSize={"lg"}
                    px={4}
                    onClick={email}
                    align={"center"}
                  >
                    {"aayushsharma11403@gmail.com"}
                  </Text>
                  <ModalCloseButton />

                  <ModalBody>
                    <FormControl>
                      <FormLabel>Subject</FormLabel>
                      <Input
                        placeholder="Hi ayush👋🏻, This is regarding.."
                        type="text"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                    </FormControl>
                    <FormControl>
                      <br />
                      <FormLabel>Body</FormLabel>
                      <Textarea
                        placeholder="That we approve you as spiderMan🕸️"
                        resize="vertical"
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                      />
                    </FormControl>
                  </ModalBody>

                  <ModalFooter>
                    <Button colorScheme="red" mr={3} onClick={onClose}>
                      Close
                    </Button>
                    <Button colorScheme={`teal`} onClick={sendEmail}>
                      Send
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </HStack>
          </Center>
        </Container>

        <Testimonials />
      </Container>
    </>
  );
}